(ns quuppa.qsm.qpe-boot-events
  (:require [re-frame.core :as rf]))

(rf/reg-event-fx
  :qpe-boot/event-report
  (fn [_ [_ notification]]
    {:fx [[:dispatch [:notifications/notify notification]]]}))
